import React from 'react';
import styled from 'styled-components';
import SystemStatusWidget from './systemStatusWidget/SystemStatusWidget';

const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  background-color: var(--background-secondary);
  border-top: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-size: 0.75rem;
  min-height: 28px;
`;

const VersionInfo = styled.div`
  font-size: 0.75rem;
`;

interface FooterProps {
  version: string;
}

const Footer: React.FC<FooterProps> = ({ version }) => {
  return (
    <FooterContainer>
      <VersionInfo>Hospital Dashboard v0.1.7</VersionInfo>
      <SystemStatusWidget />
    </FooterContainer>
  );
};

export default Footer;
